import { Draft } from '@/types';

export const getConfiguration = (draft: Pick<Draft, 'configurations'>, configurationId: number) =>
  draft.configurations[configurationId];
